"use client";

import React from "react";
import Image from "next/image";

interface Expert {
  id: number;
  Name: string;
  Designation: string;
  Content: string;
  image: {
    url: string;
    alternativeText: string;
  };
}

interface ExpertDeskProps {
  data: Expert[];
}

const ExpertDesk: React.FC<ExpertDeskProps> = ({ data }) => {
  const isEmpty = !data || data.length === 0;

  return (
    <>
      <div className="md:block hidden bg-[linear-gradient(0deg,#fff_0%,#d6ebff_100%)] relative flex flex-col w-full justify-center items-center md:pt-[60px] pt-[32px] md:pb-[60px] pb-[32px]">
        <div>
          <h2 className="text-center text-[20px] md:text-[32px] font-semibold tracking-[-1.76px] text-[#000000]">
            Meet Our <br className="md:hidden block" />
            <span className="visit_txt pr-1 !tracking-[-1.76px]">Expert</span>
          </h2>
          <div className="flex items-center md:w-[10%] w-1/2 justify-center mx-auto">
            <div className="bg-[#FFBA00] rounded h-[2px] w-[90%] mr-[5px]" />
            <div className="bg-[#FFBA00] rounded h-[2px] w-[8%] mr-[5px]" />
            <div className="bg-[#FFBA00] rounded h-[2px] w-[5%]" />
          </div>
        </div>

        {isEmpty ? (
          <p className="text-white text-center mt-4">
            No experts available at the moment.
          </p>
        ) : (
          <div className="flex flex-wrap justify-center mt-12 gap-10">
            {data?.map((expert) => (
              <div
                key={expert.id}
                className="relative w-[280px] h-[315px] rounded-[12px] p-[24px] overflow-hidden bg-cover bg-center border-[1px] border-[#FFFFFFCC]/80"
              >
                <Image
                  src={expert.image.url}
                  alt={expert.image.alternativeText || "Expert Image"}
                  className="absolute inset-0 w-full h-full object-cover rounded-[12px]"
                  width={280}
                  height={315}
                />
                <div className="pointer-events-none absolute inset-x-0 bottom-0 h-2/3 rounded-b-[12px] bg-[linear-gradient(0deg,rgba(0,0,0,0.95)_0%,rgba(0,0,0,0.55)_55%,rgba(0,0,0,0)_100%)]" />
                <div className="absolute bottom-0 left-0 p-2">
                  <p className="font-bold text-[#FFF] md:text-[24px] text-[14px]">
                    {expert.Name}
                  </p>
                  <p className="font-bold text-[#FFFFFFCC]/80 md:text-[14px] text-[14px]">
                    {expert.Designation}
                  </p>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>

      <div className="md:hidden block bg-[linear-gradient(0deg,#fff_0%,#d6ebff_100%)] relative flex flex-col w-full justify-center items-center py-5">
        <div>
          <h2 className="text-center text-[20px] md:text-[32px] font-semibold tracking-[-1.76px] text-[#000000]">
            Meet Our{" "}
            <span className="visit_txt pr-1 !tracking-[-1.76px]">Expert</span>
          </h2>
          <div className="flex items-center md:w-[10%] w-1/2 justify-center mx-auto">
            <div className="bg-[#FFBA00] rounded h-[2px] w-[90%] mr-[5px]" />
            <div className="bg-[#FFBA00] rounded h-[2px] w-[8%] mr-[5px]" />
            <div className="bg-[#FFBA00] rounded h-[2px] w-[5%]" />
          </div>
        </div>

        {isEmpty ? (
          <p className="text-white text-center mt-4">
            No experts available at the moment.
          </p>
        ) : (
          <div className="max-w-[100%] flex flex-nowrap overflow-x-auto pt-5 gap-4 px-4 scrollbar-hide">
            {data?.map((expert) => (
              <div
                key={expert.id}
                className="relative flex-shrink-0 w-[280px] h-[315px] rounded-[12px] p-[24px] overflow-hidden bg-cover bg-center border-[1px] border-[#FFFFFFCC]/80"
              >
                <Image
                  src={expert.image.url}
                  alt={expert.image.alternativeText || "Expert Image"}
                  className="absolute inset-0 w-full h-full object-cover rounded-[12px]"
                  width={280}
                  height={315}
                />
                <div className="pointer-events-none absolute inset-x-0 bottom-0 h-2/3 rounded-b-[12px] bg-[linear-gradient(0deg,rgba(0,0,0,0.95)_0%,rgba(0,0,0,0.55)_55%,rgba(0,0,0,0)_100%)]" />
                <div className="absolute bottom-0 left-0 p-2">
                  <p className="font-bold text-[#FFF] md:text-[24px] text-[14px]">
                    {expert.Name}
                  </p>
                  <p className="font-bold text-[#FFFFFFCC]/80 md:text-[14px] text-[14px]">
                    {expert.Designation}
                  </p>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </>
  );
};

export default ExpertDesk;
